import React, { useCallback } from 'react';
import { GroupSearchResult } from 'graphql/types';
import { GroupSelectCount } from '../constant';
import { useGroupSelectLabel } from '../hooks/useGroupSelectType';
import { GroupSelect } from '../GroupSelect';
import { GroupSelectDropdownProp } from '../types';
import { useSelectSearchAction } from './hooks/useSelectSearchAction';

const emptyData: GroupSearchResult[] = [];

export const CostCentersSelect: React.FC<GroupSelectDropdownProp> = ({
  groupType,
  rowID,
  defaultValues,
  classes
}: GroupSelectDropdownProp) => {
  const {
    searchHandler,
    data: { costCenters: costCentersData },
    loading: { costCenters: costCentersLoading }
  } = useGroupSelectLabel();

  const costCenters =
    costCentersData?.groupsSearch?.costCenters.items || emptyData;
  const hasMore = costCenters.length === GroupSelectCount;
  const { handleSearch } = useSelectSearchAction(searchHandler);

  const onOpen = useCallback(() => {
    handleSearch(groupType, null);
  }, [groupType, handleSearch]);

  return (
    <GroupSelect
      groupType={groupType}
      onOpen={onOpen}
      handleSearch={handleSearch}
      options={costCenters}
      hasMore={hasMore}
      loading={costCentersLoading}
      rowID={rowID}
      defaultValues={defaultValues}
      classes={classes}
    />
  );
};
